export function getPlaceIcon(address: string) {
    if (address.toLowerCase().includes("hotel")) {
        return (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V9C3 8.45 3.19583 7.97917 3.5875 7.5875C3.97917 7.19583 4.45 7 5 7H7V5C7 4.45 7.19583 3.97917 7.5875 3.5875C7.97917 3.19583 8.45 3 9 3H15C15.55 3 16.0208 3.19583 16.4125 3.5875C16.8042 3.97917 17 4.45 17 5V11H19C19.55 11 20.0208 11.1958 20.4125 11.5875C20.8042 11.9792 21 12.45 21 13V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H13V17H11V21H5ZM5 19H7V17H5V19ZM5 15H7V13H5V15ZM5 11H7V9H5V11ZM9 15H11V13H9V15ZM9 11H11V9H9V11ZM9 7H11V5H9V7ZM13 15H15V13H13V15ZM13 11H15V9H13V11ZM13 7H15V5H13V7ZM17 19H19V17H17V19ZM17 15H19V13H17V15Z"
                    fill="#5C728F"
                />
            </svg>
        );
    }
    if (
        address.toLowerCase().includes("bus station") ||
        address.toLowerCase().includes("autobus")
    ) {
        return (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M6 21C5.71667 21 5.47917 20.9042 5.2875 20.7125C5.09583 20.5208 5 20.2833 5 20V17.95C4.7 17.6167 4.45833 17.2458 4.275 16.8375C4.09167 16.4292 4 15.9833 4 15.5V6C4 4.61667 4.64167 3.60417 5.925 2.9625C7.20833 2.32083 9.23333 2 12 2C14.8667 2 16.9167 2.30833 18.15 2.925C19.3833 3.54167 20 4.56667 20 6V15.5C20 15.9833 19.9083 16.4292 19.725 16.8375C19.5417 17.2458 19.3 17.6167 19 17.95V20C19 20.2833 18.9042 20.5208 18.7125 20.7125C18.5208 20.9042 18.2833 21 18 21H17C16.7167 21 16.4792 20.9042 16.2875 20.7125C16.0958 20.5208 16 20.2833 16 20V19H8V20C8 20.2833 7.90417 20.5208 7.7125 20.7125C7.52083 20.9042 7.28333 21 7 21H6ZM6 10H18V7H6V10ZM8.5 16C8.91667 16 9.27083 15.8542 9.5625 15.5625C9.85417 15.2708 10 14.9167 10 14.5C10 14.0833 9.85417 13.7292 9.5625 13.4375C9.27083 13.1458 8.91667 13 8.5 13C8.08333 13 7.72917 13.1458 7.4375 13.4375C7.14583 13.7292 7 14.0833 7 14.5C7 14.9167 7.14583 15.2708 7.4375 15.5625C7.72917 15.8542 8.08333 16 8.5 16ZM15.5 16C15.9167 16 16.2708 15.8542 16.5625 15.5625C16.8542 15.2708 17 14.9167 17 14.5C17 14.0833 16.8542 13.7292 16.5625 13.4375C16.2708 13.1458 15.9167 13 15.5 13C15.0833 13 14.7292 13.1458 14.4375 13.4375C14.1458 13.7292 14 14.0833 14 14.5C14 14.9167 14.1458 15.2708 14.4375 15.5625C14.7292 15.8542 15.0833 16 15.5 16Z"
                    fill="#5c728f"
                />
            </svg>
        );
    }
    if (address.toLowerCase().includes("railway") || address.toLowerCase().includes("nádraží")) {
        return (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M4 15.5V6C4 5.11667 4.22917 4.4125 4.6875 3.8875C5.14583 3.3625 5.75 2.9625 6.5 2.6875C7.25 2.4125 8.10417 2.22917 9.0625 2.1375C10.0208 2.04583 11 2 12 2C13.1 2 14.1375 2.04583 15.1125 2.1375C16.0875 2.22917 16.9375 2.4125 17.6625 2.6875C18.3875 2.9625 18.9583 3.3625 19.375 3.8875C19.7917 4.4125 20 5.11667 20 6V15.5C20 16.4833 19.6625 17.3125 18.9875 17.9875C18.3125 18.6625 17.4833 19 16.5 19L18 20.5V21H16L14 19H10L8 21H6V20.5L7.5 19C6.51667 19 5.6875 18.6625 5.0125 17.9875C4.3375 17.3125 4 16.4833 4 15.5ZM6 10H11V7H6V10ZM13 10H18V7H13V10ZM8.5 16C8.93333 16 9.29167 15.8583 9.575 15.575C9.85833 15.2917 10 14.9333 10 14.5C10 14.0667 9.85833 13.7083 9.575 13.425C9.29167 13.1417 8.93333 13 8.5 13C8.06667 13 7.70833 13.1417 7.425 13.425C7.14167 13.7083 7 14.0667 7 14.5C7 14.9333 7.14167 15.2917 7.425 15.575C7.70833 15.8583 8.06667 16 8.5 16ZM15.5 16C15.9333 16 16.2917 15.8583 16.575 15.575C16.8583 15.2917 17 14.9333 17 14.5C17 14.0667 16.8583 13.7083 16.575 13.425C16.2917 13.1417 15.9333 13 15.5 13C15.0667 13 14.7083 13.1417 14.425 13.425C14.1417 13.7083 14 14.0667 14 14.5C14 14.9333 14.1417 15.2917 14.425 15.575C14.7083 15.8583 15.0667 16 15.5 16Z"
                    fill="#5c728f"
                />
            </svg>
        );
    }
    if (address.toLowerCase().includes("airport") || address.toLowerCase().includes("letiště")) {
        return (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M6.85005 17.15L3.65005 15.4L4.70005 14.35L7.20005 14.7L11.1 10.8L3.30005 6.55005L4.70005 5.15005L14.25 7.60005L18.1751 3.72505C18.4584 3.44172 18.8126 3.30005 19.2376 3.30005C19.6626 3.30005 20.0167 3.44172 20.3001 3.72505C20.5834 4.00838 20.7251 4.36255 20.7251 4.78755C20.7251 5.21255 20.5834 5.56672 20.3001 5.85005L16.4 9.75005L18.8501 19.3L17.4501 20.7L13.2 12.9L9.30005 16.8L9.65005 19.3L8.60005 20.35L6.85005 17.15Z"
                    fill="#5c728f"
                />
            </svg>
        );
    }
    if (address.toLowerCase().includes("zoo")) {
        return (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M10 18L8.35 22L6.5 21.25L7.95 17.725C6.18333 17.2583 4.75 16.3083 3.65 14.875C2.55 13.4417 2 11.8167 2 10V6C2 4.9 2.39167 3.95833 3.175 3.175C3.95833 2.39167 4.9 2 6 2C6.36667 2 6.71667 2.0625 7.05 2.1875C7.38333 2.3125 7.71667 2.44167 8.05 2.575L14 5L10 6.5V8L17.85 13H10C9.45 13 8.97917 12.8042 8.5875 12.4125C8.19583 12.0208 8 11.55 8 11H6C6 12.1 6.39167 13.0417 7.175 13.825C7.95833 14.6083 8.9 15 10 15H21L22 20H20L19 18H14V22H12V18H10ZM6 5C5.71667 5 5.47917 5.09583 5.2875 5.2875C5.09583 5.47917 5 5.71667 5 6C5 6.28333 5.09583 6.52083 5.2875 6.7125C5.47917 6.90417 5.71667 7 6 7C6.28333 7 6.52083 6.90417 6.7125 6.7125C6.90417 6.52083 7 6.28333 7 6C7 5.71667 6.90417 5.47917 6.7125 5.2875C6.52083 5.09583 6.28333 5 6 5Z"
                    fill="#5c728f"
                />
            </svg>
        );
    }
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 12C12.55 12 13.0208 11.8042 13.4125 11.4125C13.8042 11.0208 14 10.55 14 10C14 9.45 13.8042 8.97917 13.4125 8.5875C13.0208 8.19583 12.55 8 12 8C11.45 8 10.9792 8.19583 10.5875 8.5875C10.1958 8.97917 10 9.45 10 10C10 10.55 10.1958 11.0208 10.5875 11.4125C10.9792 11.8042 11.45 12 12 12ZM12 22C9.31667 19.7167 7.3125 17.5958 5.9875 15.6375C4.6625 13.6792 4 11.8667 4 10.2C4 7.7 4.80417 5.70833 6.4125 4.225C8.02083 2.74167 9.88333 2 12 2C14.1167 2 15.9792 2.74167 17.5875 4.225C19.1958 5.70833 20 7.7 20 10.2C20 11.8667 19.3375 13.6792 18.0125 15.6375C16.6875 17.5958 14.6833 19.7167 12 22Z"
                fill="#5c728f"
            />
        </svg>
    );
}
